import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import {
  SellarImportIssueCreditNoteCreateRequestType,
  SellarImportIssueCreditNoteCreateResponseType,
} from "@sellar-io/api-v2/types";

export const useSellarImportIssueCreditNote = (id: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: SellarImportIssueCreditNoteCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `orders/v2/${id}/issue-sellar-import-credit-note`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SellarImportIssueCreditNoteCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Orders, id],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderDocument],
      });
    },
  });
};
